<template>
  <div :class="$style.userCredits">
    <p v-if="isLoggedIn">
      {{ $t('navBar.youhave') }}
      <span :class="$style.credits">{{ credits }}</span>
      {{ $t('navBar.credits') }}
    </p>
    <PageControl href="/shop/credits" primary v-if="isLoggedIn">
      {{ $t('navBar.buyCreditsMenuButton') }}
    </PageControl>
    <PageControl href='/login' primary v-else>
      {{ $t('navBar.loginButton') }}
    </PageControl>
    <slot />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PageControl from '@/components/molecules/PageControl';

export default {
  name: 'UserCredits',
  components: { PageControl },
  computed: {
    ...mapState(['userStore']),
    credits() {
      return this.userStore.user.credits || 0;
    },
    isLoggedIn() {
      return this.userStore.loggedIn;
    }
  }
};
</script>

<style module>
.user-credits > * {
  margin: 0;
}

.credits {
  color: $primaryColor;
  font-size: 1.1em;
  font-weight: 900;
}
</style>
